import * as React from "react";
import { Mutation, MutationFn } from "react-apollo";
import {
  ChangePasswordMutation,
  ChangePasswordMutationVariables
} from "../../__generated__/types";
import { CHANGE_PW_QUERY } from "./queries";

class ChangePwMutation extends Mutation<ChangePasswordMutation> {}

export interface Props {
  children(
    props: MutationFn<ChangePasswordMutation, ChangePasswordMutationVariables>
  ): JSX.Element | null;
}

export interface State {}

export default class ChangePassword extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <ChangePwMutation mutation={CHANGE_PW_QUERY}>
        {result => this.props.children(result)}
      </ChangePwMutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/ChangePassword/ChangePassword.tsx